import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=701a75da&scoped=true&"
import script from "./SendMail.vue?vue&type=script&lang=js&"
export * from "./SendMail.vue?vue&type=script&lang=js&"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=701a75da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a75da",
  null
  
)

export default component.exports